import SearchableCountrySelect from "../../../components/SearchableCountrySelect";
import { useRegister } from "../RegisterContext";
import { LEVELS } from "../data/levels";
import { useTranslation } from "react-i18next";


const COACH_LICENSES = [
    "UEFA Pro",
    "UEFA A",
    "UEFA B",
    "UEFA C",
    "CAF Pro",
    "CAF A",
    "CAF B",
    "CAF C",
    "Licence nationale",
];

const REFEREE_LICENSES = [
    "FIFA Referee",
    "Arbitre international",
    "Arbitre national",
    "Arbitre régional",
    "Arbitre district",
    "Assistant referee FIFA",
    "VAR certified",
];

export default function StaffForm() {
    const {
        handleChange,
        handleDetailsChange,
        fieldErrors,
        formData,
        details,
        PHONE_RULES,
        passwordStrength,
        countries
    } = useRegister();

    const { t } = useTranslation();

    const getCountryTranslation =
        (country) => {

            return t(
                `athleteForm.${country.toLowerCase()}`
            );

        };

    const status = details.status || "";

    const isCoach = status === "staffForm.coach";
    const isReferee = status === "staffForm.referee";

    const showPosition = isCoach;
    const showLicence = isCoach || isReferee;

    const licences = isCoach
        ? COACH_LICENSES
        : isReferee
            ? REFEREE_LICENSES
            : [];

    return (
        <form
            id="register-step-form"
            className="register-form-grid"
        >
            <div className="input-wrapper">
                <label className="register-date-label" htmlFor="staff-birthdate">
                    {t("athleteForm.birthdate")}
                </label>
                <input
                    id="staff-birthdate"
                    required
                    autoComplete="off"
                    className={`register-inputs ${fieldErrors.username ? "input-error" : ""
                        }`}
                    name="username"
                    value={formData.username || ""}
                    placeholder={
                        t("athleteForm.username")
                    }
                    onChange={handleChange}
                />

                {fieldErrors.username && (
                    <div className="error-message">
                        <span className="error-icon">✖</span>
                        {fieldErrors.username}
                    </div>
                )}
            </div>

            <input
                required
                className="register-inputs"
                name="lastname"
                value={formData.lastname || ""}
                placeholder={
                    t("athleteForm.lastname")
                }
                onChange={handleChange}
            />

            <input
                required
                className="register-inputs"
                name="firstname"
                value={formData.firstname || ""}
                placeholder={
                    t("athleteForm.firstname")
                }
                onChange={handleChange}
            />

            <div className="input-wrapper">
                <input
                    required
                    className={`register-inputs ${fieldErrors.email ? "input-error" : ""
                        }`}
                    name="email"
                    type="email"
                    autoComplete="new-email"
                    value={formData.email || ""}
                    placeholder={
                        t("athleteForm.email")
                    }
                    onChange={handleChange}
                />

                {fieldErrors.email && (
                    <div className="error-message">
                        <span className="error-icon">✖</span>
                        {fieldErrors.email}
                    </div>
                )}
            </div>

            <div className="input-wrapper">
                <input
                    className={`register-inputs ${fieldErrors.password
                        ? "input-error"
                        : passwordStrength.valid
                            ? "input-success"
                            : ""
                        }`}
                    type="password"
                    name="password"
                    autoComplete="new-password"
                    placeholder={
                        t("athleteForm.password")
                    }
                    value={formData.password || ""}
                    onChange={handleChange}
                />

                {formData.password && (
                    <>
                        <div className="password-strength-bar">
                            <span
                                style={{
                                    width: `${passwordStrength.score * 20}%`,
                                }}
                                className={
                                    passwordStrength.score <= 2
                                        ? "weak"
                                        : passwordStrength.score <= 4
                                            ? "medium"
                                            : "strong"
                                }
                            />
                        </div>

                        <small className="password-message">
                            {passwordStrength.message}
                        </small>
                    </>
                )}
            </div>

            <div className="input-wrapper">
                <input
                    required
                    className="register-inputs"
                    name="birthdate"
                    value={formData.birthdate || ""}
                    type="date"
                    onChange={handleChange}
                />

                {fieldErrors.birthdate && (
                    <div className="error-message">
                        <span className="error-icon">✖</span>
                        {fieldErrors.birthdate}
                    </div>
                )}
            </div>

            <input
                required
                className="register-inputs"
                name="address"
                value={formData.address || ""}
                placeholder={
                    t("athleteForm.address")
                }
                onChange={handleChange}
            />

            <input
                required
                className="register-inputs"
                name="postal_code"
                value={formData.postal_code || ""}
                placeholder={
                    t("athleteForm.postalCode")
                }
                onChange={handleChange}
            />



            <select
                required
                className="register-select"
                name="sport"
                value={details.sport || ""}
                onChange={handleDetailsChange}
            >
                <option value="">{t("athleteForm.sport")}</option>
                <option value="Football">
                    {t("athleteForm.football")}
                </option>

                <option disabled style={{ color: "#999" }}>
                    {t("athleteForm.basketSoon")}
                </option>

                <option disabled style={{ color: "#999" }}>
                    {t("athleteForm.handballSoon")}
                </option>
            </select>

            <SearchableCountrySelect
                required
                className="register-select"
                name="country"
                value={formData.country || ""}
                onChange={handleChange}
            >
                <option value="">
                    {t("athleteForm.country")}
                </option>

                {countries.map((country) => (
                    <option
                        key={country.code}
                        value={country.name}
                    >
                        {country.flag} {country.name}
                    </option>
                ))}
            </SearchableCountrySelect>

            <select
                required
                className="register-select"
                name="language"
                value={formData.language}
                onChange={handleChange}
            >

                <option value="">
                    {t("athleteForm.language")}
                </option>

                <option value="fr">
                    🇫🇷 Français
                </option>

                <option value="en">
                    🇬🇧 English
                </option>

                <option value="ar">
                    🇲🇦 العربية
                </option>

                <option value="es">
                    🇪🇸 Español
                </option>
                <option value="pt">🇵🇹 Português</option>
                <option value="zh">🇨🇳 中文（简体）</option>
                <option value="de">🇩🇪 Deutsch</option>
                <option value="ru">🇷🇺 Русский</option>
                <option value="it">🇮🇹 Italiano</option>
                <option value="sr">🇷🇸 Srpski</option>

            </select>

            <div className="input-wrapper">
                <input
                    required
                    className={`register-inputs ${fieldErrors.phone ? "input-error" : ""
                        }`}
                    name="phone"
                    value={formData.phone || ""}
                    placeholder={
                        PHONE_RULES[formData.country]?.placeholder ||
                        t("athleteForm.phone")
                    }
                    onChange={handleChange}
                />

                {fieldErrors.phone && (
                    <div className="error-message">
                        <span className="error-icon">✖</span>
                        {fieldErrors.phone}
                    </div>
                )}
            </div>

            <select
                required
                className="register-select"
                name="status"
                value={details.status || ""}
                onChange={(e) => {
                    handleDetailsChange(e);
                }}
            >
                <option value="">{t("staffForm.status")}</option>
                <option value="staffForm.coach">
                    {t("staffForm.coach")}
                </option>
                <option value="staffForm.fitnessCoach">
                    {t("staffForm.fitnessCoach")}
                </option>

                <option value="staffForm.scout">
                    {t("staffForm.scout")}
                </option>

                <option value="staffForm.videoAnalyst">
                    {t("staffForm.videoAnalyst")}
                </option>

                <option value="staffForm.physio">
                    {t("staffForm.physio")}
                </option>

                <option value="staffForm.nutritionist">
                    {t("staffForm.nutritionist")}
                </option>

                <option value="staffForm.mentalCoach">
                    {t("staffForm.mentalCoach")}
                </option>

                <option value="staffForm.referee">
                    {t("staffForm.referee")}
                </option>
            </select>

            {showPosition && (
                <select
                    required
                    className="register-select"
                    name="position"
                    value={details.position || ""}
                    onChange={handleDetailsChange}
                >
                    <option value="">{t("athleteForm.position")}</option>
                    <option value="mainCoach">
                        {t("staffForm.mainCoach")}
                    </option>

                    <option value="assistantCoach">
                        {t("staffForm.assistantCoach")}
                    </option>

                    <option value="goalkeeperCoach">
                        {t("staffForm.goalkeeperCoach")}
                    </option>

                    <option value="tacticalCoach">
                        {t("staffForm.tacticalCoach")}
                    </option>

                    <option value="performanceAnalyst">
                        {t("staffForm.performanceAnalyst")}
                    </option>

                    <option value="trainingManager">
                        {t("staffForm.trainingManager")}
                    </option>
                </select>
            )}

            <select
                required
                className="register-select"
                name="level"
                value={details.level || ""}
                onChange={handleDetailsChange}
            >
                <option value="">{t("athleteForm.level")}</option>
                {LEVELS.map((l) => (
                    <option key={l.value} value={l.value}>{t(l.label)}</option>
                ))}
            </select>



            {showLicence && (
                <select
                    required
                    className="register-select"
                    name="licence"
                    value={details.licence || ""}
                    onChange={handleDetailsChange}
                >
                    <option value="">{t("staffForm.licence")}</option>

                    {licences.map((licence) => (
                        <option
                            key={licence}
                            value={licence}
                        >
                            {licence}
                        </option>
                    ))}
                </select>
            )}
        </form>
    );
}
